import { useEffect } from "react";

// Dependency-free schema.org JSON-LD injector. Adds a <script type="application/ld+json">
// to <head> and removes it on unmount / data change so AI assistants and search engines
// read accurate, page-specific structured data.
export function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => { const ex = document.getElementById(id); if (ex) ex.remove(); };
  }, [id, JSON.stringify(data)]);
  return null;
}

// Keeps the document title + meta description in sync per page for accurate representation.
export function usePageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
      m.setAttribute("content", description);
    }
  }, [title, description]);
}
